import React from "react";

import { TUserProfileModal } from "~/pages/BaseStaff/EmployeeProfileViewing/EmployeeProfileView/hooks/useUserProfileNavigation";
import { TEmployeeProfileUser } from "~/pages/BaseStaff/EmployeeProfileViewing/EmployeeProfileView/model/types";

import UserProfileModal from "./UserProfileModal";

interface IUserProfileModalsProps {
  openModal: TUserProfileModal;
  createdByUser?: TEmployeeProfileUser | null;
  lastEditByUser?: TEmployeeProfileUser | null;
  onClose: () => void;
}

const MODAL_CONFIG: Record<
  Exclude<TUserProfileModal, "">,
  {
    titleKey: string;
    getUser: (
      props: IUserProfileModalsProps,
    ) => TEmployeeProfileUser | null | undefined;
  }
> = {
  Profile: {
    titleKey: "employee.whoCreated",
    getUser: ({ createdByUser }) => createdByUser,
  },
  lastEditBy: {
    titleKey: "employee.wholastEditBy",
    getUser: ({ lastEditByUser }) => lastEditByUser,
  },
};

const UserProfileModals = ({
  openModal,
  createdByUser,
  lastEditByUser,
  onClose,
}: IUserProfileModalsProps) => {
  const activeModal = openModal ? MODAL_CONFIG[openModal] : null;
  const activeUser = activeModal
    ? activeModal.getUser({ openModal, createdByUser, lastEditByUser, onClose })
    : null;

  return (
    <UserProfileModal
      isOpen={Boolean(activeModal)}
      titleKey={activeModal?.titleKey}
      user={activeUser}
      onClose={onClose}
      withDivider
    />
  );
};

export default UserProfileModals;
